import React from "react";

const WidgetOpcionesConfirmar = (props) => {
    const enviarMensajeComoUsuario = (texto, handler) => {
        // Agregar el mensaje como si fuera del usuario
        props.setState((prevState) => ({
            ...prevState,
            messages: [
                ...prevState.messages,
                { message: texto, type: "user" }, // Mensaje del usuario
            ],
        }));

        // Llamar al manejador correspondiente
        handler();
    };

    const opciones = [
        {
            text: "Sí",
            handler: () => enviarMensajeComoUsuario("Sí", () => props.actionProvider.manejarFlujoVenta("sí")),
            id: 1,
        },
        {
            text: "No, editar",
            handler: () => enviarMensajeComoUsuario("No, editar", () => props.actionProvider.manejarFlujoVenta("no")),
            id: 2,
        },
    ];

    return (
        <div className={"chat-options-container"}>
            {opciones.map((opcion) => (
                <button
                    className="chat-option-button px-3"
                    key={opcion.id}
                    onClick={opcion.handler}
                >
                    {opcion.text}
                </button>
            ))}
        </div>
    );
};

export default WidgetOpcionesConfirmar;
